import { AxiosError } from 'axios'
import toastCaller, { ToastType } from './toastCaller'

export const GENERIC_SERVER_ERROR_MESSAGE =
	'Something went wrong on our end. Please try again in few minutes.'
export const SERVER_ERROR_TOAST_ID = 'SERVER_ERROR'

export const getErrorData = (
	error: unknown,
): { errorMessageCode?: string; errorMessage?: string } => {
	const defaultMessage = 'Error'

	if (error && typeof error === 'object') {
		const axiosError = error as AxiosError<{ errors?: string[] }>

		if (axiosError.response?.data?.errors?.length) {
			return { errorMessageCode: axiosError.response.data.errors[0] as string }
		}

		if (axiosError.response?.status === 500) {
			return { errorMessage: GENERIC_SERVER_ERROR_MESSAGE }
		}

		const responseMessage = (axiosError.response?.data as { message?: string })
			?.message
		if (responseMessage) {
			return { errorMessage: responseMessage }
		}

		if (axiosError.message) {
			return { errorMessage: axiosError.message as string }
		}
	}

	return { errorMessage: defaultMessage }
}

export const handleApiError = (
	error: unknown,
	objectName?: string | null,
	type?: ToastType,
) => {
	const { errorMessage, errorMessageCode } = getErrorData(error)
	const axiosError = error as AxiosError<{ errors?: string[] }>
	const isServerError = axiosError?.response?.status === 500

	toastCaller({
		errorMessageCode: errorMessageCode,
		message: errorMessage,
		objectName,
		type,
		...(isServerError ? { toastId: SERVER_ERROR_TOAST_ID, update: true } : {}),
	})
}
